import type { ImgHTMLAttributes } from 'react'

import type { ResizeFit, ServerlessCombineImagesHandlerProps } from './types'
import { getServerlessCombineImagesHandlerUrl } from './helpers'

type Props = ServerlessCombineImagesHandlerProps & ImgHTMLAttributes<HTMLImageElement>

export default function CombineImages(props: Props): React.ReactElement {
  const { bucket, fit = 'cover', srcKeys, height, width, lazyLoad, outFileKey, ...rest } = props
  if (!srcKeys.length) {
    return <></>
  }
  const loading = lazyLoad ? 'lazy' : 'eager'
  const imageUrl = getCombineImagesUrl(srcKeys, height, width, fit, bucket, outFileKey)

  return (
    <picture>
      <img height={height} loading={loading} src={imageUrl} width={width} {...rest} />
    </picture>
  )
}

export function getCombineImagesUrl(
  fileKeys: string[],
  height: number | undefined,
  width: number | undefined,
  fit: ResizeFit,
  bucketKey: string | undefined,
  outFileKey: string | undefined,
): string {
  const params = {
    bucketKey,
    fileKeys,
    size: {
      height,
      width,
      fit,
    },
    outFileKey,
  }

  const url = getServerlessCombineImagesHandlerUrl(params)

  return url
}
